import React from "react";
import styles from "./Header.module.css";

export default function Header({ title ,style}) {
   return <div className={`${styles.headerStyle}`} style={style}>{title}</div>;
}
